import { Dialog } from "../ui/Dialog"
import { SettingsContent } from "../Settings/SettingsCommon"

export function SettingsDialog() {
	return (
		<Dialog trackingViewName="settings_dialog">
			<SettingsContent layout="tabs" />
		</Dialog>
	)
}
